<button class="filter-button" [matBadge]="selectedValues.length" [matBadgeHidden]="selectedValues.length === 0"
  mat-button [matMenuTriggerFor]="optionsMenu" (menuOpened)="onSearchMenuOpened()">{{
  labelText }}
  <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
</button>

<mat-menu #optionsMenu="matMenu">
  <div class="header">
    <mat-form-field (click)="$event.stopPropagation()" appearance="outline" subscriptSizing="dynamic"
      class="header-mat-form-field">
      <mat-label>Sök på filtervärden</mat-label>
      <div class="header-content-container">
        <input matInput type="text" [(ngModel)]="query" placeholder="Sök" #queryInput (click)="$event.stopPropagation()"
          (keyup)="filterSelectableValuesByQuery()" class="search-input">
        <div class="header-action-buttons">
          <mat-icon matSuffix>search</mat-icon>
          @if (query) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearQuery()">
            <mat-icon>close</mat-icon>
          </button>
          }
        </div>
      </div>

    </mat-form-field>
  </div>

  <div class="filter-search-list">
    <mat-selection-list [(ngModel)]="selectedValues" [compareWith]="compareByValue">
      @for (filter of filteredValues; track filter) {
      <mat-list-option checkboxPosition="before" (click)="onCheckboxClicked($event)" [value]="filter">
        {{ filter.value }}
      </mat-list-option>
      }
    </mat-selection-list>
  </div>
  <div class="buttons-wrapper">
    <div class="filter-search-reset">
      <button [disabled]="selectedValues.length === 0" mat-stroked-button
        (click)="resetSelectedValues(); $event.stopPropagation();">
        Rensa filter
      </button>
    </div>

    <div class="filter-search-select">
      <button [disabled]="selectedValues.length === allValues.length" mat-stroked-button
        (click)="selectAllFilteredValues(); ">
        Markera alla
      </button>
    </div>
  </div>
</mat-menu>